import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MenuState {
  open: boolean;
}

const initialState: MenuState = {
  open: true,
};

export const MenuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setSideMenu: (state, action: PayloadAction<boolean>) => {
      return {
        open: action.payload
      };
    },
  },
});

export const {
  setSideMenu,
} = MenuSlice.actions;

